/* @ngInject */
const myCheckbox = (
  valueHandler
) => {
  return {
    restrict: 'E',
    scope: {
      myId: '@',
      myLabel: '=',
      myDisabled: '=?',
      ngModel: '=',
      myInit: '=?',
      myChange: '&?',
    },
    template: require('./myCheckbox.html'),

    /* @ngInject */
    controller: ($scope) => {

    },

    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {
        if (valueHandler.isNotNull(scope.myInit)) {
          scope.ngModel = scope.myInit
        }

        scope.$watch('myInit', (newValue, oldValue) => {
          if (newValue !== oldValue && valueHandler.isNotNull(newValue)) {
            scope.ngModel = scope.myInit
          }
        })
      },
    },
  }
}

export default myCheckbox



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/inputs/myCheckbox.js